import { render, staticRenderFns } from "./UsuariosFichajes.vue?vue&type=template&id=2449ad04&scoped=true&"
import script from "./UsuariosFichajes.vue?vue&type=script&lang=ts&"
export * from "./UsuariosFichajes.vue?vue&type=script&lang=ts&"
import style0 from "./UsuariosFichajes.vue?vue&type=style&index=0&id=2449ad04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2449ad04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
